class QuickSearch extends QuickSearchBase {
	constructor(el) {
		super(el);
	}
}
